import React from "react";
import { PageTemplate, PageTemplateProps } from "src/components/common/PageTemplate.tsx";
import { ErpUnitsDataGrid } from "src/components/views/erp/warehouse/basedata/ErpUnitsDataGrid.tsx";

export interface ErpUnitsPageProps extends PageTemplateProps {
}

export const ErpUnitsPage = React.memo((props: ErpUnitsPageProps) => {
	return <PageTemplate {...props}>
		<ErpUnitsDataGrid />
	</PageTemplate>;
});